import Vue from 'vue'
import Router from 'vue-router'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5c9f64cf = () => interopDefault(import('..\\pages\\access-your-account.vue' /* webpackChunkName: "pages_access-your-account" */))
const _09afbb5e = () => interopDefault(import('..\\pages\\access-your-card.vue' /* webpackChunkName: "pages_access-your-card" */))
const _518aebe6 = () => interopDefault(import('..\\pages\\card-print.vue' /* webpackChunkName: "pages_card-print" */))
const _06c29ed6 = () => interopDefault(import('..\\pages\\program-requirements.vue' /* webpackChunkName: "pages_program-requirements" */))
const _a1b0b9be = () => interopDefault(import('..\\pages\\rebate-form.vue' /* webpackChunkName: "pages_rebate-form" */))
const _578517be = () => interopDefault(import('..\\pages\\unlock.vue' /* webpackChunkName: "pages_unlock" */))
const _bbbb83c8 = () => interopDefault(import('..\\pages\\errors\\400.vue' /* webpackChunkName: "pages_errors_400" */))
const _bb9f54c6 = () => interopDefault(import('..\\pages\\errors\\401.vue' /* webpackChunkName: "pages_errors_401" */))
const _bb66f6c2 = () => interopDefault(import('..\\pages\\errors\\403.vue' /* webpackChunkName: "pages_errors_403" */))
const _bb4ac7c0 = () => interopDefault(import('..\\pages\\errors\\404.vue' /* webpackChunkName: "pages_errors_404" */))
const _51ef0d46 = () => interopDefault(import('..\\pages\\errors\\500.vue' /* webpackChunkName: "pages_errors_500" */))
const _d3863cf6 = () => interopDefault(import('..\\pages\\index.vue' /* webpackChunkName: "pages_index" */))

// TODO: remove in Nuxt 3
const emptyFn = () => {}
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onComplete = emptyFn, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort)
}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: decodeURI('#{BasePath}#/'),
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/access-your-account",
    component: _5c9f64cf,
    name: "access-your-account"
  }, {
    path: "/access-your-card",
    component: _09afbb5e,
    name: "access-your-card"
  }, {
    path: "/card-print",
    component: _518aebe6,
    name: "card-print"
  }, {
    path: "/program-requirements",
    component: _06c29ed6,
    name: "program-requirements"
  }, {
    path: "/rebate-form",
    component: _a1b0b9be,
    name: "rebate-form"
  }, {
    path: "/unlock",
    component: _578517be,
    name: "unlock"
  }, {
    path: "/errors/400",
    component: _bbbb83c8,
    name: "errors-400"
  }, {
    path: "/errors/401",
    component: _bb9f54c6,
    name: "errors-401"
  }, {
    path: "/errors/403",
    component: _bb66f6c2,
    name: "errors-403"
  }, {
    path: "/errors/404",
    component: _bb4ac7c0,
    name: "errors-404"
  }, {
    path: "/errors/500",
    component: _51ef0d46,
    name: "errors-500"
  }, {
    path: "/",
    component: _d3863cf6,
    name: "index"
  }],

  fallback: false
}

export function createRouter () {
  return new Router(routerOptions)
}
